export const props = {
  /**
   * 图片url的变形钩子，viewer将使用该结果进行图片预览的加载
   */
  urlTransform: {
    type: Function,
    default: imgTag => {
      return imgTag.src;
    }
  },
  /**
   * 用于viewerjs相关的容器id标识，主要为两个，图片容器初始化的id，以及viewer容器的唯一class标识
   */
  thisId: {
    type: String,
    default: () => Math.random().toFixed(4).toString()
  },
  /**
   * 是否启用独立模式
   */
  standalone: Boolean,
  /**
   * 独立模式下的图片列表
   * 格式要求：Array<{src:string, alt:string}>
   */
  standaloneImgList: {
    type: Array,
    default: () => []
  }
};
export const model = {

  /**
   * 组件的dom
   */
  imgBox: undefined,
  /**
   * viewer对象
   */
  viewer: undefined,
  /**
   * viewer容器dom
   */
  viewerContainer: undefined,
  showStandalone:false,
  /**
   * 用于判断当前是否在预览图片
   */
  showing: false,
};
export const computed = {
  // 图片字段的加工
  loadPreFix(){
    return src =>{
      let result = '';
      if (!src) {
        return result;
      }
      if ((/^(http)/.test(src))) {
        result = src;
      } else {
        result = window.CONFIG.IMG_SERVER ? (window.CONFIG.IMG_SERVER + src) : src;
      }
      return result;
    }
  }
};
